import {Component, Input, OnInit} from '@angular/core';
import {ModalsService} from "../../services/modals.service";
import {SubscriberService} from "../../services/subscriber.service";
import {SubscriberMelody} from "../../model/subscriber-melody";
import {ContentStatus} from "../../model/content-status";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-deactivate-subscription-modal',
  templateUrl: './deactivate-subscription-modal.component.html',
  styleUrls: ['./deactivate-subscription-modal.component.css']
})
export class DeactivateSubscriptionModalComponent implements OnInit {
  @Input() privetPlus: boolean;

  requestInProgress: boolean = false;
  unsubscriptionCompleted: boolean = false;
  nextStep: boolean = false;
  subscription: Subscription = new Subscription();
  promo: boolean;

  constructor(private readonly modalsService: ModalsService,
              private readonly subscriberService: SubscriberService) {
  }

  ngOnInit(): void {
    this.subscriberService.loadSubscriptions();

    this.subscription.add(
      this.subscriberService.subscriberMelodies.subscribe((melodies: ReadonlyArray<SubscriberMelody>) => {
        this.checkSubscriberMelodies(melodies as SubscriberMelody[]);
      })
    );
  }

  close(): void {
    this.modalsService.hideModal();
  }

  showNextStep() : void {
    this.nextStep = true;
  }
  unsubscribe(): void {
    this.requestInProgress = true;
    this.subscriberService.deactivateSubscriptions(this.privetPlus)
      .subscribe(() => {
        this.subscriberService.loadSubscriptions();
        this.requestInProgress = false;
        this.unsubscriptionCompleted = true;
      });
  }

  private checkSubscriberMelodies(melodies: ReadonlyArray<SubscriberMelody>): void {
    const activeMelody = melodies?.find(m => m.contentStatus === ContentStatus.ACTIVE) ?? melodies?.[0];
    this.promo = activeMelody?.tariffType === 'PROMO';
  }
}
